export default __webpack_public_path__ + "static/media/Unum_logo_blue.1f8d37f6.png";